import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { DNSRecord, DNSRecordType, LookupResponseJSON } from './dns-record';

@Injectable()
export class DNSService {
  private rootUrl = '/api/v1/dns-record/';

  constructor(private http: HttpClient) {}

  // Handles a request error.
  //
  private static handleError(domain: string): Observable<any> {
    return of(DNSRecord.nullResponseDNSRecord(domain));
  }

  // Looks up specified types of DNS records of a domain.
  //
  public lookup(siteId: string, domain: string, recordTypes: DNSRecordType[]): Observable<DNSRecord> {
    const url = this.rootUrl;
    let params = new HttpParams({
      fromObject: {
        site_id: siteId,
        domain: domain,
      },
    });

    recordTypes.filter((value, index, array) => {
      return index === array.indexOf(value);
    });
    recordTypes.forEach((recordType) => {
      params = params.append('record_type', recordType);
    });

    return this.http.get(url, { params }).pipe(
      map((res: LookupResponseJSON) => DNSRecord.fromJSON(res.data)),
      catchError(() => DNSService.handleError(domain)),
    );
  }
}
